import './App.css';
import React from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api } from "./api/client";
import { createTheme,ThemeProvider,adaptV4Theme } from '@mui/material/styles';
import ExpandableRowEntry from "./ExpandableRowEntry";
import * as Debounce from './plug-in/DebounceSearchRender';
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
import { pageTitle } from "./i18n/messages";

class Musteriler extends React.Component {


    constructor(props) {
        super(props);
        this.state={replace: "", datas:[], childRows:[], childRowId:0, open:false,dname:"",dsource:"" };
    }

    async getDatas(){

        const res = await api.get('/lookups/musteriler', { params: { limit: 10000 } });

        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);

        const products = data.map(d => ({
            "id":d.id ,
            "ulke" :  d.ulke,
            "sehir":d.sehir ,
            "kategori" : d.kategori ,
            "temsilci" :  d.temsilci,
            "yetkili":d.yetkili,
            "adres": d.adres,
            "firma" :  d.firma,
            "musteri_id" :  d.musteri_id,
            "websitesi": d.websitesi,
            "eposta" : d.eposta,
            "telefon" : d.telefon,

        }))
        //console.log(products);
        this.setState({datas: products})

    }

    componentDidMount() {
        this.getDatas(true);
    }

    render() {
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },

            },
        }));
        const columns = [
            {
                name: "musteri_id",
                label:"Müşteri ID",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "firma",
                label:"Müşteri",
                options: {
                    filter:false,
                    sort:false,
                }
            },


            {
                name: "ulke",
                label: "Ülke",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "sehir",
                label: "Şehir",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    }
                },
            },
            {
                name: "kategori",
                label: "kategori",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    }
                    //filterList: ['Business Analyst'],
                }
            },
            {
                name: "yetkili",
                label: "Yetkili",
                options: {
                    filter: false,

                }
            },
            {
                name: "temsilci",
                label: "Müşteri Temsilcisi",
                options: {
                    /*customBodyRenderLite: (dataIndex) => {
                        let val = data[dataIndex][3];
                        return val;
                    },*/
                    filter: false,
                }
            },


            {
                name: "email",
                label:"Email",
                options: {
                    filter:false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={"mailto:"+value}  >
                                    Eposta
                                </a>
                            );

                        }
                    },
                    sort:false,
                }
            },
            {
                name: "websitesi",
                label:"WWW",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={'http://'+value} target="_blank" rel="noreferrer">
                                    Aç
                                </a>
                            );

                        }
                    },
                    sort: false
                }
            },

        ];
        const data =  this.state.datas;

        let datas=[];
        const options = {
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            searchOpen:true,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
                lineHeight:0.1
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Müşteri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: true,
            // aramanın yanında temizle butonu customSearchRender: Debounce.debounceSearchRender(500),

            renderExpandableRow: (rowData, rowMeta) => {
                console.log(rowData, rowMeta);
                return ( <ExpandableRowEntry rowData={rowData} rowMeta={rowMeta} />   );
            },
        };

        return (

            <ThemeProvider theme={myTheme}>
                 <MUIDataTable title={pageTitle("Müşteriler")} data={data} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
            </ThemeProvider>
        );

    }
}

export default Musteriler;
